import { FormData } from './IncidentLead'
import React, { ReactElement, RefObject } from 'react'
import { Icon } from '../../../components/Icon'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

export const checkValidation = (formData: FormData) => {
  if (
    formData.candidate == '' ||
    formData.severity_level == '' ||
    formData.overview == '' ||
    formData.status == ''
  ) {
    return true
  } else {
    return false
  }
}

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 4) {
    return 1
  } else {
    return Math.ceil(dataLength / 3)
  }
}

export const initialData = {
  candidate: '',
  employer: '',
  severity_level: '',
  overview: '',
  status: 'open',

  // supportRequirmentRating: '',
  immediateActionTaken: '',
  furtherActionRequired: '',
  monitoringRequired: '',
  conclusionOfOutcome: '',
}

interface Props {
  severity_level: 'well-being' | 'serious' | 'minor' | string
}

export const SeverityIcon: React.FC<Props> = ({
  severity_level,
}): ReactElement => {
  let icon: ReactElement
  let color: string
  let text: string

  switch (severity_level) {
    case 'well-being':
      icon = (
        <Icon
          name={'IconAlertTriangle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.2}
          stroke={'#02698C'}
        />
      )
      color = 'text-bluishGreen'
      text = 'Well Being'
      break
    case 'serious':
      icon = (
        <Icon
          name={'IconAlertTriangle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.5}
          stroke={'#FF6666'}
        />
      )
      color = 'text-textError'
      text = 'Serious'
      break
    case 'minor':
      icon = (
        <Icon
          name={'IconAlertCircle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.2}
          stroke={'#FFA800'}
        />
      )
      color = 'text-goldYellow'
      text = 'Minor'
      break
    default:
      icon = <></>
      color = ''
      text = ''
      break
  }

  return (
    <div className="flex items-center gap-3">
      {icon}
      <p className={`font-semibold text-sm leading-6 ${color}`}>{text}</p>
    </div>
  )
}

export function getActionMessage(action: string): string {
  switch (action) {
    case 'update':
      return 'Report Updated'
    case 'delete':
      return 'Report Deleted'
    case 'create':
      return 'Report Created'
    case 'invite-user':
      return 'User Invited'
    case 'remove-invitation':
      return 'Invitation Removed'
    default:
      return 'Invalid action'
  }
}

export const handleDownloadPdf = async (pdfRef: RefObject<HTMLElement>) => {
  const element = pdfRef.current
  if (!element) {
    return
  }

  // Ensure the element is fully visible and rendered
  element.style.height = 'auto'
  element.style.overflow = 'visible'

  const canvas = await html2canvas(element, {
    scrollX: 0,
    scrollY: -window.scrollY,
    windowWidth: document.documentElement.scrollWidth,
    windowHeight: document.documentElement.scrollHeight,
  })

  const imgData = canvas.toDataURL('image/png')
  const pdf = new jsPDF('p', 'mm', 'a4')
  const imgWidth = 210 // A4 width in mm
  const pageHeight = 295 // A4 height in mm
  const imgHeight = (canvas.height * imgWidth) / canvas.width
  let heightLeft = imgHeight
  let position = 0

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
  heightLeft -= pageHeight

  while (heightLeft >= 0) {
    position = heightLeft - imgHeight
    pdf.addPage()
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight)
    heightLeft -= pageHeight
  }

  pdf.save('Report.pdf')

  // Restore the element's original style
  element.style.height = ''
  element.style.overflow = ''
}
